var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['newsletterText', `newsletterText--${_vm.layout}`]},[_c('h3',{staticClass:"newsletterText__bigTitle"},[_vm._v(_vm._s(_vm.bigTitle))]),_vm._v(" "),_c('p',{staticClass:"newsletterText__desc"},[_vm._v(_vm._s(_vm.desc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }